import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Numeral from 'numeral';
import Sidebar from 'components/shared/sidebar/component';
import PlayersSidebar from 'components/player/shared/players-sidebar/component';
import Infobox from 'components/player/shared/infobox/component';
import Transactions from '../../../player/money/transactions/list/component';
import { SIDEBAR_MODE_PLAYER } from 'components/constants';
import clsx from 'clsx';
import { isGameInShutDownState } from 'helpers/gameUtilities';
import { setT } from 'helpers/translationUtilities';
export default function ViewMoney() {
    var navigate = useNavigate();
    var _a = useParams(), type = _a.type, accountId = _a.accountId;
    var player = useSelector(function (state) { return ({
        id: state.player.id,
        name: state.player.name,
        incomeBalance: state.player.incomeBalance,
        expenseBalance: state.player.expenseBalance,
        totalBalance: state.player.totalBalance,
        company: state.player.company
    }); });
    var company = useSelector(function (state) { return ({
        incomeBalance: state.player.company.incomeBalance,
        expenseBalance: state.player.company.expenseBalance,
        totalBalance: state.player.company.totalBalance,
        transactions: state.player.company.transactions
    }); });
    var stages = useSelector(function (state) { return state.game.stages; });
    var gameLocked = isGameInShutDownState(stages);
    var relevantAccount = type === 'player' ? player.id : player.company.id;
    var currentAccount = relevantAccount || accountId;
    var income = Numeral(player.incomeBalance).format('0,0.00');
    var expense = Numeral(player.expenseBalance).format('0,0.00');
    var total = Numeral(player.totalBalance).format('0,0.00');
    var transactionType = setT('player');
    if (type === 'company') {
        income = Numeral(company.incomeBalance).format('0,0.00');
        expense = Numeral(company.expenseBalance).format('0,0.00');
        total = Numeral(company.totalBalance).format('0,0.00');
        transactionType = setT('business');
    }
    useEffect(function () {
        if (relevantAccount && accountId !== relevantAccount) {
            navigate("/money/".concat(type, "/").concat(relevantAccount));
        }
    }, [accountId, navigate, relevantAccount, type]);
    return (React.createElement("div", { className: "playerdashboard playerdashboard--with-players-sidebar" },
        React.createElement(Sidebar, { type: SIDEBAR_MODE_PLAYER }),
        React.createElement(PlayersSidebar, null),
        desktopTransactionDetails({ income: income, expense: expense, total: total, gameLocked: gameLocked, navigate: navigate, type: type, accountId: accountId }),
        mobileTransactionDetails({ income: income, expense: expense, total: total }),
        React.createElement("button", { className: clsx(['main-button mob-player-action-button', gameLocked && 'main-button--disabled']), onClick: gameLocked ? null : function () { return navigate("/money/".concat(type, "/").concat(accountId, "/pay")); } }, setT('new_transaction')),
        React.createElement("div", { className: "infobox__header" },
            React.createElement("div", { className: "infobox__heading" }, setT('transaction_history')),
            React.createElement("div", { className: "infobox__subheading" },
                transactionType,
                " ",
                setT('transactions'))),
        React.createElement(Transactions, { type: type, currentAccount: currentAccount })));
}
function mobileTransactionDetails(_a) {
    var income = _a.income, expense = _a.expense, total = _a.total;
    return (React.createElement("div", { className: "mob-transactions-details d-none-md" },
        React.createElement("div", { className: "mob-transactions-details__item" },
            React.createElement("div", { className: "mob-transactions-details__label underline-colored-label underline-colored-label--timeline-color" }, setT('total_balance')),
            React.createElement("div", { className: "mob-transactions-details__values" }, total)),
        React.createElement("div", { className: "mob-transactions-details__item" },
            React.createElement("div", { className: "mob-transactions-details__label underline-colored-label underline-colored-label--green" }, setT('income')),
            React.createElement("div", { className: "mob-transactions-details__values" }, income)),
        React.createElement("div", { className: "mob-transactions-details__item" },
            React.createElement("div", { className: "mob-transactions-details__label underline-colored-label underline-colored-label--red" }, setT('expenses')),
            React.createElement("div", { className: "mob-transactions-details__values" }, expense))));
}
function desktopTransactionDetails(_a) {
    var income = _a.income, expense = _a.expense, total = _a.total, gameLocked = _a.gameLocked, navigate = _a.navigate, type = _a.type, accountId = _a.accountId;
    return (React.createElement("div", { className: "d-none d-block-md" },
        React.createElement("div", { className: "f-grid flex-align-items-center flex-justify-content-center" },
            React.createElement("div", { className: "f-grid-col f-grid" }, [
                { label: setT('total_balance'), value: total },
                { label: setT('income'), value: income },
                { label: setT('expenses'), value: expense }
            ].map(function (_a, i) {
                var label = _a.label, value = _a.value;
                return (React.createElement("div", { key: i, className: "f-grid-col-4" },
                    React.createElement(Infobox, { className: "infobox__wrapper--sm h-100", columns: [{ className: 'infobox__column--primary infobox__column--border-green', label: label, value: value }] })));
            })),
            React.createElement("div", { className: "f-grid-col flex-grow-0 flex-shrink-1" },
                React.createElement("button", { className: clsx(['main-button main-button--lg-fullwidth', gameLocked && 'main-button--disabled']), onClick: gameLocked ? null : function () { return navigate("/money/".concat(type, "/").concat(accountId, "/pay")); } }, setT('new_transaction'))))));
}
